// class PredictiveSearch extends HTMLElement {
//     constructor() {
//         super();

//         this.input = this.querySelector('input[type="search"]');
//         this.predictiveSearchResults = this.querySelector('#predictive-search');

//         this.input.addEventListener('input', debounce((event) => {
//             this.onChange(event);
//         }, 300).bind(this));
//     }

//     onChange() {
//         const searchTerm = this.input.value.trim();

//         if (!searchTerm.length) {
//             this.close();
//             return;
//         }

//         this.getSearchResults(searchTerm);
//     }

//     getSearchResults(searchTerm) {
//         fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
//             .then((response) => {
//                 if (!response.ok) {
//                     var error = new Error(response.status);
//                     this.close();
//                     throw error;
//                 }

//                 return response.text();
//             })
//             .then((text) => {
//                 const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
//                 this.predictiveSearchResults.innerHTML = resultsMarkup;
//                 this.open();
//             })
//             .catch((error) => {
//                 this.close();
//                 throw error;
//             });
//     }

//     open() {
//         this.predictiveSearchResults.style.display = 'block';
//     }

//     close() {
//         this.predictiveSearchResults.style.display = 'none';
//     }
// }

// customElements.define('predictive-search', PredictiveSearch);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    if (!this.input) return;

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }

        return response.text();
      })
      .then((text) => {

        const html = new DOMParser().parseFromString(text, 'text/html');

        const results = html.querySelector(
          '#shopify-section-predictive-search'
        );

        if (!results) {
          this.close();
          return;
        }

        this.predictiveSearchResults.innerHTML = results.innerHTML;

        this.open();
      })
      .catch((error) => {
        this.close();
        console.error(error);
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
}

customElements.define('predictive-search', PredictiveSearch);